/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from '@material-ui/core';

// import FormLabel from '@material-ui/core/FormLabel';
import { kycFilters } from './definitions-config';

export default forwardRef((props, ref) => {
  const [filterState, setFilterState] = React.useState('');
  // expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => {
    return {
      getModel() {
        if (filterState === 'all') return null;
        return filterState;
      },

      // setModel(model) {
      //   setFilterState(model.values.at(-1));
      // },
    };
  });

  useEffect(() => {
    filterState && props.filterChangedCallback();
  }, [filterState]);

  const handleChange = ({ target }) => {
    setFilterState(target.value);
  };

  return (
    <div className='p-4'>
      <FormControl component='fieldset'>
        <RadioGroup
          aria-label='gender'
          name='gender1'
          value={filterState}
          id='test'
          onChange={handleChange}
        >
          <FormControlLabel
            value='all'
            control={
              <Radio
                checked={filterState === '' || filterState === 'all'}
                color='primary'
                size='small'
              />
            }
            label={<span className='text-sm'>All</span>}
          />
          {props.values.map((value, index) => (
            <div key={value}>
              <FormControlLabel
                value={value}
                control={<Radio color='primary' size='small' />}
                label={<span className='text-sm'>{kycFilters[value]}</span>}
              />
            </div>
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
});
